function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, message, InputNumber, Space, Modal } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var AddVitalSigns = function AddVitalSigns(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      handler = _ref.handler;

  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      formError = _useState4[0],
      setFormError = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      formSuccess = _useState6[0],
      setFormSuccess = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      height = _useState8[0],
      setHeight = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      weight = _useState10[0],
      setWeight = _useState10[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onHeightChange = function onHeightChange(v) {
    setHeight(v);
    var bmi = weight / Math.pow(v * 0.01, 2);
    form.setFieldsValue({
      bmi: bmi
    });
  };

  var onWeightChange = function onWeightChange(v) {
    setWeight(v);
    var bmi = v / Math.pow(height * 0.01, 2);
    form.setFieldsValue({
      bmi: bmi
    });
  };

  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('temperature', values.temperature);
    formData.append('height', values.height);
    formData.append('weight', values.weight);
    formData.append('bmi', values.bmi);
    formData.append('blood_sugar', values.blood_sugar);
    formData.append('saturation', values.saturation);
    formData.append('blood_pressure_systole', values.blood_pressure_systole);
    formData.append('blood_pressure_diastole', values.blood_pressure_diastole);
    formData.append('breathe_rate', values.breathe_rate);
    formData.append('heart_rate', values.heart_rate);
    formData.append("customer_id", patient.id);
    formData.append('user_id', Common.currentUser.id);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsx("p", {
        children: "L'enregistrement des param\xE8tres"
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'addvitalsigns', formData).then(function (response) {
          if (response.data.status == 200) {
            setFormSuccess('Opération réussie');
            form.resetFields();
            handler();
          } else {
            setFormError(response.data.message);
          }
        })["catch"](function (error) {
          setFormError('Une erreur est survenue');
        })["finally"](function () {
          setIsFormLoading(false);
        });
      },
      onCancel: function onCancel() {
        setIsFormLoading(false);
      }
    });
  };

  return /*#__PURE__*/_jsx("div", {
    style: {
      padding: "12px",
      background: "#F3ECDA",
      borderRadius: "7px"
    },
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "temperature",
            label: "Temp\xE9rature",
            children: /*#__PURE__*/_jsx(InputNumber, {
              decimalSeparator: ",",
              precision: 2,
              style: {
                width: "110px"
              },
              suffix: "\xB0C"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "height",
            label: "Taille",
            children: /*#__PURE__*/_jsx(InputNumber, {
              onChange: onHeightChange,
              style: {
                width: "110px"
              },
              suffix: "Cm"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "weight",
            label: "Poids",
            children: /*#__PURE__*/_jsx(InputNumber, {
              onChange: onWeightChange,
              decimalSeparator: ",",
              precision: 2,
              style: {
                width: "110px"
              },
              suffix: "Kg"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "bmi",
            label: "IMC",
            children: /*#__PURE__*/_jsx(InputNumber, {
              decimalSeparator: ",",
              precision: 2,
              style: {
                width: "110px"
              },
              suffix: "Kg/M\xB2"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "blood_sugar",
            label: "Glyc\xE9mie",
            children: /*#__PURE__*/_jsx(InputNumber, {
              decimalSeparator: ",",
              precision: 2,
              style: {
                width: "110px"
              },
              suffix: "mmol/L"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "saturation",
            label: "SPO2",
            children: /*#__PURE__*/_jsx(InputNumber, {
              style: {
                width: "110px"
              },
              suffix: "%"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/_jsxs(Space, {
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "blood_pressure_systole",
              label: "Systole /",
              children: /*#__PURE__*/_jsx(InputNumber, {
                style: {
                  width: "80px"
                }
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "blood_pressure_diastole",
              label: "Diastole",
              children: /*#__PURE__*/_jsx(InputNumber, {
                style: {
                  width: "110px"
                },
                suffix: "mmHg"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "breathe_rate",
            label: "Freq. Resp.",
            children: /*#__PURE__*/_jsx(InputNumber, {
              style: {
                width: "110px"
              },
              suffix: "RPM"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "heart_rate",
            label: "Freq. Cardiaque",
            children: /*#__PURE__*/_jsx(InputNumber, {
              style: {
                width: "110px"
              },
              suffix: "bpm"
            })
          })
        })]
      }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Sauvegarder"
          })
        })
      })]
    })
  });
};

export default AddVitalSigns;